import React from "react";
import SurveyContainer from "../components/survey/containers/SmileysContainer";

export const Survey = () => {
	return <SurveyContainer />;
};

export default Survey;
